export const handleDownloadPdf = (fileUrl: string, filename: string) => {
  fetch(fileUrl)
    .then((res) => res.blob())
    .then((blob) => {
      // Create a temporary URL for the blob
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a temporary <a> element
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;

      // Trigger the download
      document.body.appendChild(link);
      link.click();

      // Clean up
      link.remove();
      window.URL.revokeObjectURL(blobUrl);
    })
    .catch((err) => console.error('Download error', err));
};
